import * as React from 'react';
import styled from 'styled-components';

import { InfoBox } from '@longline/aqua-ui/containers/InfoBox';
import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { NumberFormatter } from '@longline/aqua-ui/formatters/NumberFormatter';
import { LongitudeFormatter } from '@longline/aqua-ui/formatters/GIS/LongitudeFormatter';
import { LatitudeFormatter } from '@longline/aqua-ui/formatters/GIS/LatitudeFormatter';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { IStructure } from '../../types/IStructure';
import { PolygonUtils } from '../../util/PolygonUtils';
import { StructureInfoBoxHeader } from './StructureInfoBoxHeader';

interface IProps {
  value?: IStructure;
}

const StructureInfoBox = (props: IProps) => {
  const globalState = useGlobalState();

  // Optional because <ListView aux> injects the active item; render nothing
  // if no item is selected.
  if (!props.value) return null;
  const structure = props.value;

  const humanArea = (name: string, aream2: number) => {
    if(aream2 > 1000000) return <InfoBox.Row name={<>{name} <Unit>(km2)</Unit></>} value={<NumberFormatter value={aream2/1000000} decimals={0}/>}/>;
    return <InfoBox.Row name={<>{name} <Unit>(m2)</Unit></>} value={<NumberFormatter value={aream2} decimals={0}/>}/>;
  }

  const humanLength = (name: string, lengthMeters: number) => {
    if(lengthMeters > 1000) return <InfoBox.Row name={<>{name} <Unit>(km)</Unit></>} value={<NumberFormatter value={lengthMeters/1000} decimals={0}/>}/>;
    return <InfoBox.Row name={<>{name} <Unit>(m)</Unit></>} value={<NumberFormatter value={lengthMeters} decimals={0}/>}/>;
  }

  return (
    <InfoBox
      header={<StructureInfoBoxHeader value={structure}/>}
      padded
      width={300}
      footer={<>
        <TertiaryButton onClick={() => globalState.focusStructure(structure)}>FOCUS</TertiaryButton>
        <TertiaryButton onClick={() => globalState.startEditStructure()}>EDIT</TertiaryButton>
      </>}
    >
      {structure.type == 'circle' && <>
        <InfoBox.Row name="Position" value={<><LongitudeFormatter value={structure.point.lng}/>, <LatitudeFormatter value={structure.point.lng}/></>}/>
        {humanLength("Diameter", 2 * structure.radius)}
        {humanArea("Area", Math.PI * structure.radius * structure.radius)}
        {humanLength("Circumference", 2 * Math.PI * structure.radius)}
      </>}

      {structure.type == 'polygon' && <>
        <InfoBox.Row name="Position" value={<><LongitudeFormatter value={PolygonUtils.getCentroid(structure.points).lng}/>, <LatitudeFormatter value={PolygonUtils.getCentroid(structure.points).lat}/></>}/>
        <InfoBox.Row name="Points" value={structure.points.length}/>
        {humanArea("Area", PolygonUtils.getArea(structure.points))}
        {humanLength("Perimeter", PolygonUtils.getPerimeter(structure.points))}
      </>}

      <InfoBox.Row name={<>Stocking <Unit>(animals)</Unit></>} value={(structure.stocking === undefined || structure.stocking === null) ? 'not set' : <NumberFormatter value={structure.stocking} decimals={0}/>}/>

    </InfoBox>
  )
}

const Unit = styled.span`
  display: inline-block;
  font-size: 80%;
  font-weight: normal;
  color: #eee;
`

export { StructureInfoBox }
